<ng-container *ngIf="!hasError">
  <ng-container *ngIf="layout === 'fullpage'">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-container *ngIf="layout === 'default'">
    <ingo-loader
      *ngIf="!dataReady || loading; else defaultContent"
    ></ingo-loader>
    <ng-template #defaultContent>
      <ingo-global-error-container></ingo-global-error-container>

      <ng-container *ngIf="dataReady">
        <ingo-navbar
          [accessBlocked]="accessBlocked"
          [user]="user"
          [currentLanguage]="currentLanguage"
          [currentRoute]="currentRoute"
          (onSelectLanguage)="selectLanguage($event)"
          (onLogout)="logOut()"
        >
        </ingo-navbar>

        <router-outlet></router-outlet>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-container>

<ingo-global-error-container *ngIf="hasError"></ingo-global-error-container>
